<template lang="pug">
select#grade_id.form-control(v-if="this.selectedGrade === undefined", @change='onChangeGrade($event)', v-model='defaultGrade' required)
  option(disabled value='0') Chọn
  option(v-for='o in filterGrades' :selected='o.id==selectedGrade' :value='o.id') {{o.name}}
select#grade_id.form-control(v-else, @change='onChangeGrade($event)', v-model='selected' required)
  option(disabled value='0') Chọn
  option(v-for='o in filterGrades' :selected='o.id==selectedGrade' :value='o.id') {{o.name}}
</template>

<script>
export default {
  props: {
    selectedGrade: Number,
    selected_school_id: Number,
    grade_id: Array,
    grades: Array,
    schools: Array
  },
  data() {
    return {
      defaultGrade: this.grade_id ? parseInt(this.grade_id[0]) : 0
    }
  },
  methods: {
    onChangeGrade(e) {
      var id = e.target.value
      this.$emit('onGradeChange', id)
    },
    checkValue(value, arr) {
      for (var i = 0; i < arr.length; i++) {
        if (value === parseInt(arr[i])) return true
      }
      return false
    }
  },
  computed: {
    filterGrades() {
      var teachGrade = []
      var lstGrades = []
      if (this.schools) {
        for (var i = 0; i < this.schools.length; i++) {
          if (this.schools[i].id === this.selected_school_id) {
            teachGrade = this.schools[i].teach_grade
          }
        }
      }
      if (teachGrade.length) {
        for (var g = 0; g < this.grades.length; g++) {
          if (this.checkValue(this.grades[g].type_grade, teachGrade) === true) {
            lstGrades.push(this.grades[g])
          }
        }
        return lstGrades
      }
      return this.grades
    },
    selected() {
      return this.selectedGrade
    }
    // getDefaultGrade() {
    //   console.log(this.grade_id)
    //   if (this.grade_id) return parseInt(this.grade_id[0])
    //   return null
    // }
  }
}
</script>



// WEBPACK FOOTER //
// itemGrade.vue?f5e85f94